export const ActivityBar = 'ActivityBar'

export const Clock = 'Clock'

export const Counter = 'Counter'

export const DebugConsole = 'Debug Console'

export const EditorCompletion = 'EditorCompletion'

export const EditorFindWidget = 'EditorFindWidget'

export const EditorImage = 'EditorImage'

export const EditorPlainText = 'EditorPlainText'

export const EditorText = 'EditorText'

export const Explorer = 'Explorer'

export const ExtensionDetail = 'ExtensionDetail'

export const Extensions = 'Extensions'

export const Iframe = 'Iframe'

export const Implementations = 'Implementations'

export const KeyBindings = 'KeyBindings'

export const Layout = 'Layout'

export const List = 'List'

export const Locations = 'Locations'

export const Main = 'Main'

export const Noop = 'Noop'

export const Output = 'Output'

export const Panel = 'Panel'

export const Problems = 'Problems'

export const QuickPick = 'QuickPick'

export const References = 'References'

export const RunAndDebug = 'RunAndDebug'

export const Search = 'Search'

export const SideBar = 'SideBar'

export const SimpleBrowser = 'SimpleBrowser'

export const SourceControl = 'Source Control'

export const StatusBar = 'StatusBar'

export const Terminal = 'Terminal'

export const TitleBar = 'TitleBar'

export const TitleBarButtons = 'TitleBarButtons'

export const TitleBarMenuBar = 'TitleBarMenuBar'

export const TodoList = 'TodoList'
